import { ChangeDetectorRef, Component } from '@angular/core';
import { ActionSheetController, IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { SignUpProvider } from '../../providers/sign-up/sign-up'
import { ToastProvider } from '../../providers/toast/toast';
import { DashboardPage } from '../dashboard/dashboard';
import { File } from '@ionic-native/file';
import { IOSFilePicker } from '@ionic-native/file-picker';
import { UtilService } from '../../services/util';
import { environment } from '../../environments/environment';
import { HomePage } from '../home/home';
import { LoginProvider } from '../../providers/login/login';
import {	Storage} from '@ionic/storage';
import { MobileAppService } from '../../services/mobile-app';
import { ExtraProvider } from '../../providers/extra/extra';
import { ImagePickerOptions, OutputType } from '@ionic-native/image-picker';

@IonicPage()
@Component({
  selector: 'page-sign-up-form',
  templateUrl: 'sign-up-form.html',
})
export class SignUpFormPage {
  viewData: any;
  societyList: any;
  formData: any;
  society: any;
  signUpData = {}
  token: any;
  societyFlats: any;
  editForm = false;
  loader = false;
  filteredUnits = [];
  disabled_fields = {phone_no:true, email:true};
  registrationStatus = null;
  loginDetails = null;
  adminRemarks = null;
  fieldCheck: any;
  isAndroid = false;
  showBlogLink = false;
  environment = environment;
  constructor(public navCtrl: NavController,
	public navParams: NavParams,
	private signUpProvider: SignUpProvider,
	private toast: ToastProvider,
	private file: File,
	private platform : Platform,
	private filePicker: IOSFilePicker,
	private util: UtilService,
	private loginProvider: LoginProvider,
	private storage: Storage,
	private mobileAppSrv: MobileAppService,
	private extra: ExtraProvider,
	private ref: ChangeDetectorRef,
	public actionSheetController: ActionSheetController
  ) {
	this.isAndroid = this.platform.is('android');
	this.viewData = {
	  background: '/assets/images/background/26.jpg',
	  active_view : 'select-society',
	  heading : ""
	}
	this.societyList = []
	this.token = localStorage.getItem("signup_token") ;
	this.editForm = this.navParams.get("editForm");
	if (this.editForm) {
		//   signup_token  signup_user_data signup_form_data signup_society 
		this.society = JSON.parse(localStorage.getItem('signup_society'))
		var sd = JSON.parse(localStorage.getItem('signup_data'))
		this.signUpData  = JSON.parse(sd.data)[0]
		this.signUpData['id']  = sd.id;
		// this.formData = JSON.parse(localStorage.getItem('signup_data'));
		this.getSocietyForm(this.society.id);
		this.getSocietyUnit(this.society.id);
		this.viewData.active_view = 'edit-form'
		this.checkRegisterPhoneUnit(this.signUpData['flat_no'])
	}else{
		this.resetUserForm({});
	 }
  }
  resetUserForm(obj){
	this.signUpData = obj
	var userDetails = JSON.parse(localStorage.getItem("signup_user_data"));
	if(userDetails){
		this.signUpData['phone_no'] = userDetails.phone_no
		this.signUpData['name'] = userDetails.name
		this.signUpData['email'] =userDetails.email
		this.registrationStatus = null
	}
  }
  onSearchTerm(event) {
	var searchValue = event.value	
	if (searchValue.length > 3) {
		var data = {
		  search: searchValue,
		  token: this.token
		}
	  this.signUpProvider.searchSociety(data).then(val => {
		this.societyList = val.data;
		this.showBlogLink = true;
	  })
	}else{
	  this.societyList = [];
	  this.showBlogLink = false;
	}
  }
  checkRegisterPhoneUnit(unitNo){
	var societyId = this.society.id;
	var phoneNo = this.signUpData['phone_no'];
	if(unitNo){
		this.signUpProvider.getRegisterPhoneUnit(societyId, unitNo, phoneNo).then(val => {
			if(val.status == 'success' && val.data){
				this.signUpData = JSON.parse(val.data.data)[0]
				this.signUpData['id'] = val.data.id
				this.viewData.active_view = 'edit-form'
				localStorage.setItem('signup_data', JSON.stringify(val.data))
				this.requestStatus()
			}else{
				this.resetUserForm({'flat_no':unitNo})
			}
			// this.societyList = val.data;
			// this.showBlogLink = true;
		})
	}
  }
  selectSociety (society){
	if(society.config.user_registration ){
		this.society = society
		localStorage.setItem('signup_society', JSON.stringify(society))
		this.viewData.heading = society.name;
		this.getSocietyUnit(society.id);
		this.getSocietyForm(society.id)
		this.viewData.active_view = 'edit-form'
	}else{
		this.toast.presentToast((society.name)+' Registration is closed. Contact Admin for further instructions.')
	}
  }

  getSocietyForm(societyId) {
	this.loader = true
	var data = {
		formtype: 'USER_REGISTRATION',
		itemid: societyId,
		token: this.token
	  }
	  this.signUpProvider.getSocietyFrom(data).then(val => {
		if (val.status == 'success') {
		  if (val.data != null) {
			this.loader = false
			val.data.fields.forEach((val) => {
				if (val.option) {
					val['options'] = JSON.parse(val.option)
				}
			})
			this.formData = val.data
			this.societyList = []
			// this.viewData.active_view = 'edit-form'
			console.log(this.formData)
		  }else {console.log(val)}
		} else {console.log(val)}
	  })
  }

  getSocietyUnit(societyId) {
	this.loader = true
	var token = this.token
	this.signUpProvider.getUnitNo(token, societyId).then(val => {
	  this.loader = false
	  this.societyFlats = val.data.flat_nos
	})
  }
  onSearchUnitNo(search) {
	return this.societyFlats.filter(item => {
	  return item.flat_no.toLowerCase().indexOf(search.toLowerCase()) > -1;
	});
  }
  onSearchUnit(event) {
	if (this.viewData._temp_falt_no != event.value) {
	  this.filteredUnits = this.onSearchUnitNo(event.value)
	}
  }
  setUnitNo(data) {	
	this.viewData._temp_falt_no = data
	this.signUpData['flat_no'] = data
	this.filteredUnits = []
	this.checkRegisterPhoneUnit(data)
  }

  openUrl(url: string) {
	this.util.openUrl(url, '_system');
  }

  submitForm(signUpData) {
	var data = {
		token: this.token,
		societyId: this.society.id,
		formData: signUpData,
		id:signUpData.id
	}
	this.loader = true
	console.log(data);
	if (this.editForm) {
		this.signUpProvider.resubmitFromData(data).then(val => {
			this.loader = false
			if (val.status == 'success') {
				this.toast.presentToast(val.message)
				this.registerApp(signUpData.id)
				this.navCtrl.setRoot(DashboardPage);
			} else {
				this.toast.presentToast(val.message)
			}
		})
	} else {
		this.signUpProvider.submitFromData(data).then(val => {
			this.loader = false
			console.log(val)
			if (val.status == 'success') {
				this.toast.presentToast(val.message)
				localStorage.setItem('signup_login', 'true');
				localStorage.setItem('signup_data', JSON.stringify(val.data))
				this.registerApp(val.data.id)
				this.navCtrl.setRoot(DashboardPage);
			} else {
				this.toast.presentToast(val.message)
			}
		})
	}
  }
  

  onDocSelected(event, colName) {	//android
	const selectedFile=event.target.files[0];
	if(selectedFile){
		this.uploadFile(selectedFile, colName)

	}
	else{
		console.log("unable to upload files")
	}
  }

  selectDoc(colName){	//ios
	this.filePicker.pickFile()
	.then(uri => {
	  uri = 'file://'+uri
	  this.file.resolveLocalFilesystemUrl(uri)
		  .then((files)=> {
			files.filesystem.root.getFile(files.fullPath, {}, (fe)=>{
			  fe.file((file)=>{
				this.uploadFile(file, colName)
			  }, (err)=>{
				console.error(err)
			  })
			})
		}).catch((err) => {
		  alert(JSON.stringify(err, null, 4));
		});
	})
	.catch(err => {console.error(err)});
  }
  takePicture(colName) {
    this.extra.clickPicture().then(val=>{
		if(val){
			var url = 'data:image/jpeg;base64,' + val
			console.log("resized url-----", url);
			this.uploadFile(url, colName)
		}
    });
  };

  imageChoose(colName){
	var options: ImagePickerOptions = {
		maximumImagesCount: 5,
		quality: 50,
		  // width: int,
		  // height: int,
		outputType: OutputType.DATA_URL
	  }
      this.extra.imgPicker(options).then(val => {
		  val.forEach(v => {
			if(v){
				var file = 'data:image/jpeg;base64,' + v
				this.uploadFile(file, colName)
			}
		  });
      });
  }
  delFile(url, colName){
	  console.log(url,colName)
	if( colName && this.signUpData[colName]){
		this.signUpData[colName].forEach((val,k)=>{
			if(val==url){
				this.signUpData[colName].splice(k, 1)
			}
		})
	}
  }
  async selectUploadingTypes(colName){
		var buttons = [];
		buttons.push({
			text: 'Camera' ,
			icon: 'camera',
			handler: () => {
				this.takePicture(colName)
			}
		})
		buttons.push({
			text: 'Gallery' ,
			icon: 'md-images',
			handler: () => {
				this.imageChoose(colName)
			}
		})
		if(!this.isAndroid){
			buttons.push({
				text: 'Files' ,
				icon: 'md-document',
				handler: () => {
					this.selectDoc(colName)
				}
			})
		}
	  const actionSheet = await this.actionSheetController.create({
		title: "Select ",
		cssClass:'my-custom-class',
		buttons: [...buttons,
		  {
			text: 'Cancel',
			// icon: 'close',
			role: 'cancel',
			handler: () => {
			  console.log('Cancel clicked');
			}
		  }
		]
	  });
	  await actionSheet.present();
  }
  uploadFile(file, colName){
	var fd = new FormData()
	fd.append('name', (file && (typeof file == 'object' ) ? file.name :'file_'+colName))
	fd.append('type', "SIGNUP")
	fd.append("file", file)
	console.log(file)
	var token = this.token;
	this.loader = true
	this.signUpProvider.uploadDocs(fd, token).then(val => {
		console.log("url::::::" + val.data.url);
		this.signUpData[colName]= this.signUpData[colName] ? this.signUpData[colName] : []
		this.signUpData[colName].push(val.data.url)
		this.loader = false
        this.ref.detectChanges();
	}, (err)=>{
		console.log(err)
		this.loader = false
	})
  }
  ionViewDidLoad() {
  }

  requestStatus() {
	this.signUpProvider.requestStatusViaLocalStorage().then(val => {
		console.log(val)
		this.registrationStatus = val.data.status
		this.loginDetails = val.data.login_details
		this.toast.presentToast("Your Request Status : " +val.data.status)
	})
	}

	proceedLogin (){
		if(this.loginDetails && this.loginDetails.status=='success' && this.loginDetails.data){
			localStorage.removeItem('signup_login')
			localStorage.removeItem('signup_user_data')
			localStorage.removeItem('signup_society')
			localStorage.removeItem('signup_token')
			localStorage.removeItem('signup_data')
			this.storage.set("loginDetails", this.loginDetails.data)
			this.navCtrl.setRoot(HomePage);
		}else if(this.loginDetails && this.loginDetails.message){
			this.toast.presentToast(this.loginDetails.message)
		}else{
			this.toast.presentToast('Cannot Proceed Login. Contact Admin!!')
		}
	}
	logout(){
		this.loginProvider.logOut();
		this.navCtrl.setRoot(HomePage);
	}
	goto(page){
		switch (page) {
			case 'HOME':
				this.navCtrl.push(DashboardPage)
				break;
			default:
				
				break;
		}
	}
	registerApp (id){
		this.mobileAppSrv.registerAppToToken(id, this.society.id, this.token)
	}



}



// WEBPACK FOOTER //
// ./src/pages/sign-up-form/sign-up-form.ts